import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { RecordingOrder } from './RecordingOrder';
import { RecordingPrices } from './RecordingPrices';
import { RecordingRules } from './RecordingRules';

export const PhotoVideoRecording: FC = () => {
  const { t } = useTranslation();

  return (
    <section className="space-y-4 pb-10">
      <p>{t('photo-video-recording.free-recording-description')}</p>
      <p>{t('photo-video-recording.paid-recording-description')}</p>

      <RecordingPrices />

      <RecordingOrder />

      <RecordingRules />
    </section>
  );
};
